import React from 'react';
import PastImageItem from '../PastImageItem';
import usePastImagesPricelists from '../../hooks/usePastImagesPricelists';
import usePastImages from '../../hooks/usePastImages';
import pastImagesPricelistFor from '../../utils/pastImagesPricelistFor';
import { useEmailInterceptor } from '../EmailInterceptor/EmailInterceptor';
import Spinner from '../Spinner';

export default function PastImageItems({ student, onContinue, query = {} }) {
  // isFetched, not isLoading -- both queries carry `placeholderData: []`, which react-query
  // reports as success, so isLoading is false while the arrays are still empty. See the note
  // in PastImagesContent: read the wrong one and an empty placeholder passes for an answer.
  const { isFetched: pastImagesFetched, data: pastImages } = usePastImages({ studentId: student.id, additionalQuery: query });
  const { isFetched: pricelistsFetched, data: pricelists } = usePastImagesPricelists();
  const { intercept } = useEmailInterceptor();

  if (!pastImagesFetched || !pricelistsFetched) return <div style={{ margin: '0 auto' }}><Spinner color="blue" /></div>;
  if (pricelists.length === 0) return null;

  return (
    <>
      {(pastImages || []).map((studentImage) => {
        const pricelist = pastImagesPricelistFor(studentImage, pricelists);

        if (!pricelist) return null;

        const onClick = () => intercept(() => onContinue({ packageId: pricelist.id, studentImage }));

        return (
          <PastImageItem
            key={studentImage.id}
            student={student}
            pricelist={pricelist}
            studentImage={studentImage}
            onClick={onClick}
          />
        );
      })}
    </>
  );
}
